import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6">
            Ready to Ship Worldwide?
          </h2>
          <p className="text-xl text-primary-foreground/90 mb-10">
            Join thousands of businesses shipping with confidence. Get your instant quote today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/contact"
              className="px-8 py-4 bg-white text-primary rounded-lg font-semibold hover:bg-white/90 transition-all hover:scale-105 flex items-center justify-center gap-2"
            >
              <span>Get Free Quote</span>
              <Icon name="ArrowRightIcon" size={20} />
            </Link>
            <Link
              href="/track-shipment"
              className="px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-primary transition-all hover:scale-105 flex items-center justify-center gap-2"
            >
              <Icon name="MagnifyingGlassIcon" size={20} />
              <span>Track Shipment</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}